import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./indexNew.css";
import App from "./App";
//import MaintainesePage from "./MaintainesePage";
import * as serviceWorker from "./serviceWorker";
// import { isDevMode } from "./components/common/functions";
const container = document.getElementById('app-root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
    false?<StrictMode><App/></StrictMode>:<App/>
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
